<mat-form-field [class.autocompletable]="autocomplete === 'on'"
                [floatLabel]="textMask?.lazy === false ? 'always' : 'auto'">
    <mat-label *ngIf="label">{{ label }}</mat-label>
    <input [ngModel]="value"
           [required]="required"
           [disabled]="disabled"
           (blur)="blur($event)"
           (ngModelChange)="writeValue($event)"
           [placeholder]="placeholder"
           [errorStateMatcher]="errorStateMatcher"
           matInput=""
           [imask]="textMask"
           [type]="type"
           [name]="name"
           [autocomplete]="autocomplete">
    <mat-icon *ngIf="suffixIconClass" matSuffix [ngClass]="suffixIconClass"></mat-icon>
    <mat-error *ngFor="let error of (errorStateMatcher ? errorStateMatcher.errors : [])">
        {{ error.description ? error.description : error.code }}
    </mat-error>
</mat-form-field>
